export default {
	'sanchez_elementary': {
		name: 'Sanchez Elementary',
		terms: {
			'2016_2017': {
				id: '0B7M38pRihZntUThVLXlqdFdxdDQ',
				type: 'sheet',
				version: 1.0
			}
		}
	},

	'growth_schools': {
		name: 'Growth Schools',
		terms: {
			'2016_2017': {
				id: '0B7M38pRihZntdF9MY0dBMGV3REE',
				type: 'sheet',
				version: 1.0
			}
		}
	},

	'test_schedules': {
		name: 'Test Schedules',
		terms: {
			'2016_2017': {
				id: '0B7M38pRihZntVlgzV3dERVU0cG8',
				type: 'sheet',
				version: 1.0
			}
		}
	},

	'new_test': {
		name: 'New Test',
		terms: {
			'2016_2017': {
				id: '0B0WQeAm03_OZWDhCVDluLVNGRHM',
				type: 'sheet',
				version: 2.0
			}
		}
	},

	'slavens': {
		name: 'Slavens',
		terms: {
			'2016_2017': {
				id: '0B1nnQ3Qmp882OHREbnhFdU00R2M',
				type: 'sheet',
				version: 2.0
			}
		}
	},

	'demo': {
		name: 'Riverview Middle School',
		terms: {
			'2016_2017': {
				id: '0B7M38pRihZntU2ZLNTY2OFl3bDQ',
				type: 'sheet',
				version: 2.0
			},
			'period_example': {
				id: '0B7M38pRihZntMGx0RHNfVEQ4NlU',
				type: 'sheet',
				version: 2.0
			}
		}
	},

	'ccsc': {
		name: 'Community Charter School of Cambridge',
		terms: {
			'2016_2017': {
				id: '0B7M38pRihZntQm1kSDg5ZnlmYm8',
				type: 'sheet',
				version: 2.0
			}
		}
	},

	'bonsall': {
		name: 'Bonsall High School',
		terms: {
			'2016_2017': {
				id: '0B7M38pRihZntWDhHdG5LT2RNRGc',
				type: 'sheet',
				version: 2.0
			}
		}
	}
};


/** WEBPACK FOOTER **
 ** ./src/js/schools.js
 **/